export default __webpack_public_path__ + "static/media/type4_4in.2a886872.svg";